import React, { useState } from "react";
import {
  Backdrop,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";
import { css } from "@emotion/react";
import { useMutation } from "@apollo/client";
import { DeleteSampleData, DeleteSampleMutation, DeleteSampleVariables } from "./queries";
import { useHistory } from "react-router-dom";

const styles = {
  backdrop: css`
    z-index: 999,
    color: '#f00',
  `,
};

interface DeleteSampleProps {
  projectId: string;
  sampleId: string;
}

export default function DeleteSample(p: DeleteSampleProps) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [deleteSample] = useMutation<DeleteSampleData, DeleteSampleVariables>(DeleteSampleMutation, {refetchQueries: ["GetProjects", "GetProjectById"]})

  const redirectToProject = () => {
    history.replace(`/admin/sessions/${p.projectId}`)
  }
  const handleDeleteClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleConfirmDelete = () => {
    deleteSample({variables: {sample_id: p.sampleId}}).then(redirectToProject).catch(e => {
      setError(e.toString())
    });
  }

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleDeleteClick}
        disabled={open}
      >
        Delete
      </Button>
      <Backdrop
        css={styles.backdrop}
        style={{ zIndex: 999 }}
        open={open}
      >
        <Card
          css={css`
            max-width: 300px;
          `}
        >
          <CardContent>
            <Typography variant="h6">Delete Sample</Typography>
            <Typography variant="body2">
              This sample along with its QR code and any feedback
              will be permanently deleted. This action cannot be reversed.
            </Typography>
            {error ? <Typography variant="body2">
              Error deleting: {error}
            </Typography> : null}
          </CardContent>
          <CardActions>
            <Button variant="contained" onClick={handleClose}>Cancel</Button>
            <Button variant="outlined" color="secondary" onClick={handleConfirmDelete}>
              Delete
            </Button>
          </CardActions>
        </Card>
      </Backdrop>
    </React.Fragment>
  );
}
